/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Original_ShownInputs */

const en_recipe_original_shown = /** @type {(inputs: Recipe_Original_ShownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original recipe.`)
};

const de_recipe_original_shown = /** @type {(inputs: Recipe_Original_ShownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Originalrezept.`)
};

/**
* | output |
* | --- |
* | "Original recipe." |
*
* @param {Recipe_Original_ShownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_original_shown = /** @type {((inputs?: Recipe_Original_ShownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Original_ShownInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_original_shown(inputs)
	return en_recipe_original_shown(inputs)
});